(function () {
  // BGF 倒數 + 進度條共用引擎 — 單一 interval 更新整頁，成本極低。
  // [data-bgf-countdown]：文字倒數。data-bgf-mode="preorder"(默認)歸零後停用購買按鈕；data-bgf-mode="sale" 歸零後只淡出。
  // [data-bgf-bar]：進度條，帶 data-deadline 同 data-start，實時計算剩餘比例並縮短 .bgf-countdown-bar__fill 寬度。
  // 由 Claude 建立。要停用：在 bgf-brand.liquid 移除引入它的 <script> 一行即可。

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function formatRemain(ms) {
    var s = Math.floor(ms / 1000);
    var d = Math.floor(s / 86400); s %= 86400;
    var h = Math.floor(s / 3600); s %= 3600;
    var m = Math.floor(s / 60); s %= 60;
    if (d > 0) {
      return d + ' 日 ' + pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    return pad(h) + ':' + pad(m) + ':' + pad(s);
  }

  function expireScope(el) {
    if (el.classList.contains('is-expired')) return;
    el.classList.add('is-expired');

    var mode = el.getAttribute('data-bgf-mode') || 'preorder';
    var textEl = el.querySelector('.bgf-countdown__text');
    var container = el.closest('.bgf-preorder-banner, .bgf-sale-banner, .bgf-preorder-tag, .bgf-sale-badge');
    if (container) container.classList.add('is-expired');

    if (mode === 'sale') {
      if (textEl) textEl.textContent = '優惠已結束';
      if (container) {
        window.setTimeout(function () {
          container.style.display = 'none';
        }, 4000);
      }
      return;
    }

    // preorder（預設）：截止後停用購買按鈕
    if (textEl) textEl.textContent = '預訂已截止';
    var scope = el.closest('.product') || el.closest('.card-wrapper') || el.closest('quick-add-modal') || document;
    var submitButtons = scope.querySelectorAll('button[name="add"]');
    submitButtons.forEach(function (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      var label = btn.querySelector('span');
      if (label) label.textContent = '預訂已截止';
    });
  }

  function tickCountdowns(now) {
    var nodes = document.querySelectorAll('[data-bgf-countdown]:not(.is-expired)');
    nodes.forEach(function (el) {
      var deadline = parseInt(el.getAttribute('data-deadline'), 10);
      if (!deadline) return;
      var remain = deadline - now;
      if (remain <= 0) {
        expireScope(el);
        return;
      }
      var textEl = el.querySelector('.bgf-countdown__text');
      if (textEl) textEl.textContent = formatRemain(remain) + ' 後截止';
    });
  }

  function tickBars(now) {
    var bars = document.querySelectorAll('[data-bgf-bar]:not(.is-expired)');
    bars.forEach(function (bar) {
      var deadline = parseInt(bar.getAttribute('data-deadline'), 10);
      var start = parseInt(bar.getAttribute('data-start'), 10);
      var fill = bar.querySelector('.bgf-countdown-bar__fill');
      if (!deadline || !fill) return;
      if (!start || start >= deadline) start = deadline - 1;
      var total = deadline - start;
      var remain = deadline - now;
      var pct = Math.max(0, Math.min(100, (remain / total) * 100));
      fill.style.width = pct + '%';
      if (remain <= 0) {
        bar.classList.add('is-expired');
      }
    });
  }

  function tick() {
    var now = Date.now();
    tickCountdowns(now);
    tickBars(now);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
  setInterval(tick, 1000);
})();
